import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "envelope-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.7493 7.11638V16.5C21.7493 18.5712 20.0705 20.25 17.9993 20.25H5.99927C3.92805 20.25 2.24927 18.5712 2.24927 16.5V7.051C2.24927 6.9914 2.25622 6.93343 2.26936 6.87784C2.3594 5.13513 3.80076 3.75 5.56589 3.75H18.4489C20.2723 3.75 21.7499 5.22798 21.7499 7.052C21.7499 7.07349 21.7497 7.09495 21.7493 7.11638ZM3.74927 9.80768V16.5C3.74927 17.7428 4.75648 18.75 5.99927 18.75H17.9993C19.2421 18.75 20.2493 17.7428 20.2493 16.5V9.81869L15.7948 12.8388C13.5077 14.389 10.5072 14.3891 8.22009 12.8388L3.74927 9.80768ZM20.2497 7.026C20.2494 7.03463 20.2493 7.0433 20.2493 7.052V7.09951C20.234 7.67905 19.9401 8.21691 19.459 8.54222L18.116 9.45275L14.9531 11.5972C13.1742 12.8029 10.8406 12.8029 9.0617 11.5972L4.55561 8.54211C4.12472 8.25014 3.84476 7.78915 3.77953 7.2805C3.76984 7.20492 3.76489 7.12829 3.76489 7.051C3.76489 6.05621 4.57111 5.25 5.56589 5.25H18.4489C19.4348 5.25 20.2358 6.04203 20.2497 7.026Z"
    }, null, -1)
  ])))
}
export default { render: render }